import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_WHATSAPP_APP](state, payload) {
    state.app = payload;
  },
  [MutationsType.SET_WHATSAPP_APPS](state, payload) {
    state.apps = payload;
  },
  [MutationsType.ADD_WHATSAPP_APP](state, payload) {
    if (state.apps) state.apps.unshift(payload);
  },
  [MutationsType.UPDATE_WHATSAPP_APP](state, payload) {
    if (state.app && state.app.id === payload.id) state.app = payload;

    let ind = (state.apps || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.apps, ind, payload);
  },
  [MutationsType.DELETE_WHATSAPP_APP](state, payload) {
    let ind = (state.apps || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.apps, ind);
  },
  [MutationsType.SET_WHATSAPP_PHONE_NUMBERS](state, payload) {
    state.phoneNumbers = payload;
  },
  [MutationsType.UPDATE_WHATSAPP_PHONE_NUMBER](state, payload) {
    if (state.app && state.app.id === payload.id) state.app = payload;

    let ind = (state.apps || []).findIndex((t) => t.phone_number_id === payload.phone_number_id);
    if (ind >= 0) Vue.set(state.apps, ind, payload);
  },
  [MutationsType.ADD_WHATSAPP_PHONE_NUMBER](state, payload) {
    if (state.phoneNumbers) state.phoneNumbers.unshift(payload);
  },
  [MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATE](state, payload) {
    state.messageTemplate = payload;
  },
  [MutationsType.SET_WHATSAPP_MESSAGE_TEMPLATES](state, payload) {
    state.messageTemplates = payload;
  },
  [MutationsType.ADD_WHATSAPP_MESSAGE_TEMPLATE](state, payload) {
    if (state.messageTemplates) state.messageTemplates.unshift(payload);
  },
  [MutationsType.UPDATE_WHATSAPP_MESSAGE_TEMPLATE](state, payload) {
    let ind = (state.messageTemplates || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.messageTemplates, ind, payload);
  },
  [MutationsType.DELETE_WHATSAPP_MESSAGE_TEMPLATE](state, payload) {
    let ind = (state.messageTemplates || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.messageTemplates, ind);
  },
  [MutationsType.SET_WHATSAPP_QUICK_REPLY](state, payload) {
    state.quickReply = payload;
  },
  [MutationsType.SET_WHATSAPP_QUICK_REPLIES](state, payload) {
    state.quickReplies = payload;
  },
  [MutationsType.ADD_WHATSAPP_QUICK_REPLY](state, payload) {
    if (state.quickReplies) state.quickReplies.unshift(payload);
  },
  [MutationsType.UPDATE_WHATSAPP_QUICK_REPLY](state, payload) {
    let ind = (state.quickReplies || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.quickReplies, ind, payload);
  },
  [MutationsType.DELETE_WHATSAPP_QUICK_REPLY](state, payload) {
    let ind = (state.quickReplies || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.quickReplies, ind);
  },
  [MutationsType.SET_TEAM_SCHEMA](state, payload) {
    state.schema = payload.data;
  },
};
